import type { FiscalPeriodConfig } from 'utils/fiscalPeriods';

interface Props {
  readonly config: FiscalPeriodConfig;
}

/** Collapsible JSON dump of the config value that would be persisted. */
export const ConfigJsonPreview = ({ config }: Props) => (
  <details>
    <summary className="text-muted small mb-2">JSON that would be stored as the config value</summary>
    <pre className="fiscal-period-editor__json mb-0">{JSON.stringify(config, null, 2)}</pre>
  </details>
);
